import { useMutation, useQuery, skipToken } from "@tanstack/react-query"
import {
  generateShortkeyLink,
  getECLAccount,
  createShopper,
  saveShopper,
  getShopper,
} from "./shoppers"
import { shoppersKeys } from "./queryKeys"
import type { IGetECLAccountParams } from "./types"

export const useGenerateShortkeyLinkMutation = () => {
  return useMutation({
    mutationFn: generateShortkeyLink,
  })
}

export const useGetECLAccountQuery = (
  market_code?: string,
  params?: IGetECLAccountParams,
) => {
  return useQuery({
    queryKey: shoppersKeys.eclAccount(market_code, params),
    queryFn:
      params && market_code
        ? () => getECLAccount(market_code, params)
        : skipToken,
  })
}

export const useSaveShopperMutation = () => {
  return useMutation({
    mutationFn: saveShopper,
  })
}

export const useCreateShopperMutation = () => {
  return useMutation({
    mutationFn: createShopper,
  })
}

export const useGetShopperQuery = (shopper_guid?: string | null) => {
  return useQuery({
    queryKey: shoppersKeys.detail(shopper_guid),
    queryFn: shopper_guid ? () => getShopper(shopper_guid) : skipToken,
  })
}
